// extracted by mini-css-extract-plugin
export var footer = "_pz-0";
export var inherit = "_pz-1";
export var input = "_pz-2";
export var modalContent = "_pz-3";
export var quillEditor = "_pz-4";
export var subtitle = "_pz-5";